const VOICE_CALL_TIMESTAMP_RE = /\[Voice Call (\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})\]/g;

const MONTH_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const formatCallDateTime = (day, month, year, hour24, minute) => {
  const hour = parseInt(hour24, 10);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour % 12 || 12;
  const monthIdx = parseInt(month, 10) - 1;
  const monthLabel = MONTH_SHORT[monthIdx] || month;
  return `${parseInt(day, 10)} ${monthLabel} ${year}, ${hour12}:${minute} ${ampm}`;
};

/** Parse call_summary into entries; `text` is the full stored line (same as old remarks). */
export const parseVoiceCallEntries = (callSummary) => {
  const text = (callSummary || '').trim();
  if (!text) return [];

  const matches = [];
  VOICE_CALL_TIMESTAMP_RE.lastIndex = 0;
  let match = VOICE_CALL_TIMESTAMP_RE.exec(text);
  while (match) {
    matches.push({
      raw: match[0],
      day: match[1],
      month: match[2],
      year: match[3],
      hour24: match[4],
      minute: match[5],
      endIndex: VOICE_CALL_TIMESTAMP_RE.lastIndex,
      startIndex: match.index,
    });
    match = VOICE_CALL_TIMESTAMP_RE.exec(text);
  }

  if (matches.length === 0) {
    return [{ raw: '', formatted: '', text, body: text, timestamp: 0 }];
  }

  const entries = matches.map((m, index) => {
    const lineEnd = index + 1 < matches.length ? matches[index + 1].startIndex : text.length;
    const lineText = text.slice(m.startIndex, lineEnd).trim();
    const body = text.slice(m.endIndex, lineEnd).trim();
    const ts = new Date(
      parseInt(m.year, 10),
      parseInt(m.month, 10) - 1,
      parseInt(m.day, 10),
      parseInt(m.hour24, 10),
      parseInt(m.minute, 10),
    ).getTime();
    return {
      raw: m.raw,
      formatted: formatCallDateTime(m.day, m.month, m.year, m.hour24, m.minute),
      text: lineText,
      body,
      timestamp: Number.isNaN(ts) ? 0 : ts,
    };
  });

  return entries.sort((a, b) => a.timestamp - b.timestamp);
};

/** Latest call label for compact table display. */
export const formatLatestCallLabel = (callSummary) => {
  const entries = parseVoiceCallEntries(callSummary);
  if (entries.length === 0) return null;
  return entries[entries.length - 1].formatted || null;
};

export const customerHasCallSummary = (customer) => (
  !!(customer?.call_summary && customer.call_summary.trim() !== '')
);
